import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "variant", "height", "width", "right", "top"],
    _excluded2 = ["iconTop", "iconLeft", "iconSize", "dismissIconSize", "dismissIconTop", "dismissIconRight", "theme", "children", "variant", "IconComponent", "dismissable", "onDismiss", "visible"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled, { withTheme } from 'styled-components';
import Panel from '../Panel';
import Alert from '../Icons/AlertIcon';
import CheckmarkCircle from '../Icons/CheckmarkCircleIcon';
import Info from '../Icons/InfoIcon';
import WarningTriangleFilled from '../Icons/WarningTriangleFilledIcon';
import CloseIcon from '../Icons/CloseIcon';
import Box from '../Box';
import GearThin from '../Icons/GearThinIcon';
import { useThemeDefaults } from '../utils';
import { focusVisibleStyle } from '../focus';

var noop = function noop() {};

var pickIcon = function pickIcon(_ref) {
  var variant = _ref.variant;
  return variant === 'info' ? Info : variant === 'success' ? CheckmarkCircle : variant === 'error' ? Alert : variant === 'warning' ? WarningTriangleFilled : GearThin;
};

var DismissButtonWrapper = styled(Box).withConfig({
  displayName: "Banner__DismissButtonWrapper",
  componentId: "sc-1se5bqw-0"
})(["", ""], focusVisibleStyle);

var DismissButton = function DismissButton(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant,
      height = _ref2.height,
      width = _ref2.width,
      right = _ref2.right,
      top = _ref2.top,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(DismissButtonWrapper, _extends({
    position: "absolute",
    as: "button",
    cursor: "pointer",
    right: right,
    top: top,
    role: "button",
    tabIndex: "0"
  }, props), /*#__PURE__*/React.createElement(CloseIcon, {
    color: pickDismissIconColor({
      variant: variant,
      theme: theme
    }),
    display: "block",
    width: width,
    height: height
  }));
};

var pickColor = function pickColor(_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;
  return theme.panelColors[variant].iconColor;
};

var pickDismissIconColor = function pickDismissIconColor(_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return variant === 'warning' ? theme.colors.labelCaption : pickColor({
    theme: theme,
    variant: variant
  });
};

export var BannerIcon = function BannerIcon(_ref5) {
  var variant = _ref5.variant,
      top = _ref5.top,
      left = _ref5.left,
      width = _ref5.width,
      height = _ref5.height,
      theme = _ref5.theme;
  return /*#__PURE__*/React.createElement(pickIcon({
    variant: variant
  }), {
    position: 'absolute',
    width: width,
    height: height,
    top: top,
    left: left,
    color: pickColor({
      variant: variant,
      theme: theme
    })
  });
};
var Banner = withTheme(function (_ref6) {
  var iconTop = _ref6.iconTop,
      iconLeft = _ref6.iconLeft,
      iconSize = _ref6.iconSize,
      dismissIconSize = _ref6.dismissIconSize,
      dismissIconTop = _ref6.dismissIconTop,
      dismissIconRight = _ref6.dismissIconRight,
      theme = _ref6.theme,
      children = _ref6.children,
      _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? 'standard' : _ref6$variant,
      _ref6$IconComponent = _ref6.IconComponent,
      IconComponent = _ref6$IconComponent === void 0 ? BannerIcon : _ref6$IconComponent,
      dismissable = _ref6.dismissable,
      _ref6$onDismiss = _ref6.onDismiss,
      onDismiss = _ref6$onDismiss === void 0 ? noop : _ref6$onDismiss,
      _ref6$visible = _ref6.visible,
      visible = _ref6$visible === void 0 ? true : _ref6$visible,
      props = _objectWithoutProperties(_ref6, _excluded2);

  return visible ? /*#__PURE__*/React.createElement(Panel, _extends({
    panelColors: variant,
    position: "relative"
  }, props), /*#__PURE__*/React.createElement(IconComponent, {
    top: iconTop,
    left: iconLeft,
    width: iconSize,
    height: iconSize,
    variant: variant,
    theme: theme
  }), children, dismissable && /*#__PURE__*/React.createElement(DismissButton, {
    variant: variant,
    theme: theme,
    width: dismissIconSize,
    height: dismissIconSize,
    right: dismissIconRight,
    top: dismissIconTop,
    onClick: onDismiss
  })) : null;
});
export var Page = useThemeDefaults(function (_ref7) {
  var theme = _ref7.theme,
      dismissable = _ref7.dismissable;
  return {
    pl: theme.bannerPadding.pageLeft,
    pr: theme.bannerPadding[dismissable ? 'pageDismissableRight' : 'pageRight'],
    pt: theme.bannerPadding.pageTop,
    pb: theme.bannerPadding.pageBottom,
    iconTop: theme.bannerPadding.pageIconTop,
    iconLeft: theme.bannerPadding.pageIconLeft,
    iconSize: theme.bannerPadding.pageIconSize,
    dismissIconTop: theme.bannerPadding.pageDismissIconTop,
    dismissIconRight: theme.bannerPadding.dismissIconRight,
    dismissIconSize: theme.bannerPadding.dismissIconSize
  };
}, Banner);
Page.propTypes = _objectSpread({}, Panel.propTypes);
export var Inline = useThemeDefaults(function (_ref8) {
  var theme = _ref8.theme,
      dismissable = _ref8.dismissable;
  return {
    pt: theme.bannerPadding.inlineTop,
    pr: theme.bannerPadding[dismissable ? 'inlineDismissableRight' : 'inlineRight'],
    pb: theme.bannerPadding.inlineBottom,
    pl: theme.bannerPadding.inlineLeft,
    iconTop: theme.bannerPadding.inlineIconTop,
    iconLeft: theme.bannerPadding.inlineIconLeft,
    iconSize: theme.bannerPadding.inlineIconSize,
    dismissIconTop: theme.bannerPadding.inlineDismissIconTop,
    dismissIconRight: theme.bannerPadding.dismissIconRight,
    dismissIconSize: theme.bannerPadding.dismissIconSize
  };
}, Banner);
Inline.propTypes = _objectSpread({}, Panel.propTypes);